import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import EventBusyIcon from '@material-ui/icons/EventBusy';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '12px',
    maxWidth: '450px',
    width: '100%',
  },
  // ── Connected card ──────────────────────────────
  connectedCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    borderRadius: '6px',
    backgroundColor: green[50],
    border: `1px solid ${green[200]}`,
  },
  connectedInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: green[800],
    fontSize: '13px',
    fontWeight: 600,
  },
  connectedIcon: {
    fontSize: '20px',
    color: green[700],
  },
  disconnectBtn: {
    flexShrink: 0,
    marginLeft: '12px',
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark,
      backgroundColor: 'rgba(211,47,47,0.06)',
    },
  },
  // ── Connect card ────────────────────────────────
  connectCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    borderRadius: '6px',
    backgroundColor: theme.palette.shade4.main,
    border: `1px solid ${theme.palette.shade4.dark}`,
  },
  connectInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: theme.palette.shade2.main,
    fontSize: '13px',
    fontWeight: 500,
  },
  connectIcon: {
    fontSize: '20px',
    color: theme.palette.shade2.main,
  },
  connectBtn: {
    flexShrink: 0,
    marginLeft: '12px',
  },
  error: {
    color: theme.palette.error.main,
    marginTop: '6px',
    fontSize: '12px',
  },
}));

export default function CalendlyConnectButton(props) {
  const { isConnecting, isConnected, error, openPopup, disconnect } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {isConnected ? (
        <div
          className={classes.connectedCard}
          data-testid="calendly-connected-card"
        >
          <div className={classes.connectedInfo}>
            <EventAvailableIcon className={classes.connectedIcon} />
            Calendly Connected
          </div>
          <Button
            variant="outlined"
            size="small"
            type="button"
            className={classes.disconnectBtn}
            data-testid="calendly-disconnect-button"
            onClick={disconnect}
            startIcon={<EventBusyIcon />}
          >
            Disconnect
          </Button>
        </div>
      ) : (
        <div
          className={classes.connectCard}
          data-testid="calendly-connect-card"
        >
          <div className={classes.connectInfo}>
            <CalendarTodayIcon className={classes.connectIcon} />
            Connect your Calendly account
          </div>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            type="button"
            className={classes.connectBtn}
            data-testid="calendly-connect-button"
            onClick={openPopup}
            disabled={isConnecting}
            startIcon={<CalendarTodayIcon />}
          >
            {isConnecting ? 'Connecting...' : 'Connect'}
          </Button>
        </div>
      )}
      {error && (
        <p className={classes.error} data-testid="calendly-connect-error">
          {error}
        </p>
      )}
    </div>
  );
}
